// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.card.mat-elevation-z6 {
  margin-top: 1.25rem;
}

.application-card .card-body {
  background-color: #f7f7f4;
}

.icon-shape-primary {
  color: #37479d;
  background-color: rgba(138, 152, 235, 0.5);
}

.icon-shape {
  padding: 12px;
  text-align: center;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
}

.icon {
  width: 3rem;
  height: 3rem;
}

.text-primary {
  color: #3f51b3 !important;
}

.text-uppercase {
  text-transform: uppercase !important;
}

.badge {
  color: #37479d;
  background-color: rgba(138, 152, 235, 0.5);
  padding: 0.45rem;
  font-size: 80%;
}

.radio-group-container {
  padding: 1rem 0 0.25rem 0;
  display: flex;
  justify-content: center;
}

.mat-radio-group {
  font-size: initial;
}

.mat-radio-button {
  margin-right: 16px;
}

.status_bar {
  height: 0.1rem;
  border-bottom-left-radius: 0.25rem;
  border-bottom-right-radius: 0.25rem;
}

.accepted {
  background-color: #006300;
  border-color: #449d44;
  color: #fff;
  font-weight: 600;
}

.rejected {
  background-color: #A72925;
  border-color: #d9534f;
  color: #fff;
  font-weight: 600;
}

.pending {
  background-color: #3f51b3;
  border-color: #3f51b3;
}

button.cancelled {
  margin: 0.25rem;
}

button.accepted {
  margin: 0.25rem;
}

.map_container {
  min-height: 240px;
  height: 100%;
}

.applications_dont_exist {
  letter-spacing: 0.5px;
  font-weight: 500;
  font-size: 1.2rem;
  display: flex;
  align-items: center;
  min-height: 60vh;
  justify-content: center;
}`, "",{"version":3,"sources":["webpack://./src/app/admin/dashboard/certification/certification.component.scss"],"names":[],"mappings":"AAAA;EACI,mBAAA;AACJ;;AAEA;EACI,yBAAA;AACJ;;AAEA;EACI,cAAA;EACA,0CAAA;AACJ;;AAEA;EACI,aAAA;EACA,kBAAA;EACA,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;AACJ;;AAEA;EACI,WAAA;EACA,YAAA;AACJ;;AAEA;EACI,yBAAA;AACJ;;AAEA;EACI,oCAAA;AACJ;;AAEA;EACI,cAAA;EACA,0CAAA;EACA,gBAAA;EACA,cAAA;AACJ;;AA6CA;EACI,yBAAA;EACA,aAAA;EACA,uBAAA;AA1CJ;;AA6CA;EACI,kBAAA;AA1CJ;;AA6CA;EACI,kBAAA;AA1CJ;;AA6CA;EACI,cAAA;EACA,kCAAA;EACA,mCAAA;AA1CJ;;AA6CA;EACI,yBAAA;EAEA,qBAAA;EACA,WAAA;EACA,gBAAA;AA3CJ;;AA8CA;EACI,yBAAA;EAEA,qBAAA;EACA,WAAA;EACA,gBAAA;AA5CJ;;AAgDA;EAII,yBAAA;EACA,qBAAA;AAhDJ;;AAmDA;EACI,eAAA;AAhDJ;;AAmDA;EACI,eAAA;AAhDJ;;AAmDA;EACI,iBAAA;EACA,YAAA;AAhDJ;;AAmDA;EACI,qBAAA;EACA,gBAAA;EACA,iBAAA;EACA,aAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;AAhDJ","sourcesContent":[".card.mat-elevation-z6 {\r\n    margin-top: 1.25rem;\r\n}\r\n\r\n.application-card .card-body {\r\n    background-color: #f7f7f4;\r\n}\r\n\r\n.icon-shape-primary {\r\n    color: #37479d;\r\n    background-color: rgba(138,152,235,.5);\r\n}\r\n\r\n.icon-shape {\r\n    padding: 12px;\r\n    text-align: center;\r\n    display: inline-flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n    border-radius: 50%;\r\n}\r\n\r\n.icon {\r\n    width: 3rem;\r\n    height: 3rem;\r\n}\r\n\r\n.text-primary {\r\n    color: #3f51b3!important;\r\n}\r\n\r\n.text-uppercase {\r\n    text-transform: uppercase!important;\r\n}\r\n\r\n.badge {\r\n    color: #37479d;\r\n    background-color: rgba(138,152,235,.5);\r\n    padding: 0.45rem;\r\n    font-size: 80%\r\n\r\n}\r\n\r\n\r\n// mat-expansion-panel-header {\r\n//     // background-color: #c3cbf7 !important\r\n//     background-color: #edeff9 !important\r\n// }\r\n\r\n// mat-expansion-panel-healer.mat-expanded {\r\n//     // background-color: #c3cbf7\r\n//     background-color: #edeff9 !important\r\n// }\r\n\r\n// .mat-expansion-panel-body div:first-child {\r\n//     padding-top: 16px !important\r\n// }\r\n// .background_initial {\r\n//     background-color: initial;\r\n//     border-style: solid;\r\n//     border-width: 0.2rem;\r\n//     border-radius: 0.2rem;\r\n//     padding: 0.3rem 0.6rem;\r\n//     font-size: 1.2rem;\r\n//     font-weight: bold;\r\n//     letter-spacing: 1px;\r\n//     transform: rotate(-5deg);\r\n//     opacity: 0.95;\r\n//     // box-shadow: 1px 1px 2px 1px;\r\n//     font-family: 'Courier';\r\n//     text-transform: uppercase;\r\n//     -webkit-mask-image: url('/assets/images/grunge.png');\r\n//     mask-image: url('/assets/images/grunge.png');\r\n//     -webkit-mask-size: 944px 604px;\r\n//     mask-size: 944px 604px;\r\n//     color: #fff;\r\n// }\r\n\r\n// .card-headings span {\r\n//     margin-right: 8px;\r\n// }\r\n\r\n// .mat-radio-button ~ .mat-radio-button {\r\n//     margin-left: 16px;\r\n// }\r\n.radio-group-container {\r\n    padding: 1rem 0 0.25rem 0;\r\n    display: flex;\r\n    justify-content: center;\r\n}\r\n\r\n.mat-radio-group {\r\n    font-size: initial;\r\n}\r\n\r\n.mat-radio-button {\r\n    margin-right: 16px;\r\n}\r\n\r\n.status_bar {\r\n    height: .1rem;\r\n    border-bottom-left-radius:.25rem;\r\n    border-bottom-right-radius:.25rem;\r\n}\r\n\r\n.accepted {\r\n    background-color: #006300;\r\n    // color: #449d44;\r\n    border-color: #449d44;\r\n    color: #fff;\r\n    font-weight: 600\r\n}\r\n\r\n.rejected {\r\n    background-color: #A72925;\r\n    // color: #d9534f;\r\n    border-color: #d9534f;\r\n    color: #fff;\r\n    font-weight: 600\r\n\r\n}\r\n\r\n.pending {\r\n    // background-color: #337ab7;\r\n    // color: #337ab7;\r\n    // border-color: #337ab7;\r\n    background-color: #3f51b3;\r\n    border-color: #3f51b3;\r\n}\r\n\r\nbutton.cancelled {\r\n    margin: .25rem\r\n}\r\n\r\nbutton.accepted {\r\n    margin: .25rem\r\n}\r\n\r\n.map_container {\r\n    min-height: 240px;\r\n    height: 100%;\r\n}\r\n\r\n.applications_dont_exist {\r\n    letter-spacing: 0.5px;\r\n    font-weight: 500;\r\n    font-size: 1.2rem;\r\n    display: flex;\r\n    align-items: center;\r\n    min-height: 60vh;\r\n    justify-content: center;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
